import { Link } from 'react-router-dom'
import LegalDocumentLayout from '../components/LegalDocumentLayout'
import { LEGAL } from '../config/legal'

const TermsOfUsePage = () => (
  <LegalDocumentLayout eyebrow="Legal" title="Termos de Uso">
    <p className="text-gray-600 dark:text-gray-400 text-sm">
      Última atualização: {LEGAL.lastUpdated}
    </p>

    <p>
      Bem-vindo ao <strong className="text-gray-900 dark:text-white">{LEGAL.brand}</strong>. Ao utilizar nossa
      plataforma web, aplicativo ou serviços de monitoramento de volume, você concorda com estes Termos de
      Uso e com a{' '}
      <Link
        to="/privacidade"
        className="text-accent font-semibold hover:underline focus:outline-none rounded"
      >
        Política de Privacidade
      </Link>
      .
    </p>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        1. Objeto do serviço
      </h2>
      <p>
        O {LEGAL.brand} oferece monitoramento remoto de nível e volume em reservatórios, alertas, histórico de
        leituras, planos de assinatura e funcionalidades complementares descritas no site e no aplicativo.
        O serviço depende de dispositivo compatível, conexão à internet e configuração correta pelo usuário.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        2. Cadastro e conta
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>Você deve fornecer informações verdadeiras e mantê-las atualizadas.</li>
        <li>É responsável pela confidencialidade da sua senha e por atividades realizadas na sua conta.</li>
        <li>O cadastro é permitido apenas a pessoas com 18 anos ou mais.</li>
        <li>Podemos suspender ou encerrar contas que violem estes termos ou a legislação aplicável.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        3. Planos, pagamentos e cancelamento
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Planos pagos são cobrados conforme a periodicidade escolhida (mensal ou anual) via central de pagamentos
          (cartão, PIX ou boleto).
        </li>
        <li>
          Planos mensais podem ser recorrentes; planos anuais seguem as condições exibidas no checkout (renovação
          automática no cartão ou pagamento único via PIX, conforme opção selecionada).
        </li>
        <li>
          O cancelamento encerra novas cobranças na central de pagamentos e remove o cartão salvo por segurança.
          O acesso aos recursos do plano pago permanece até o fim do ciclo já pago; após essa data, a conta
          volta ao plano Gratuito automaticamente.
        </li>
        <li>
          Reembolsos seguem a legislação consumerista e a política comercial vigente no momento da contratação.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        4. Uso aceitável
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>Utilizar o serviço apenas para fins lícitos e conforme a documentação do produto.</li>
        <li>Não tentar acessar dados de outros usuários, interferir no sistema ou realizar engenharia reversa.</li>
        <li>Manter dispositivos devidamente instalados, calibrados e conectados à internet.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        5. Isenção de responsabilidade
      </h2>
      <p className="font-bold text-gray-900 dark:text-white mb-3 uppercase tracking-wide text-xs sm:text-sm">
        Leia com atenção
      </p>
      <p className="mb-4">
        O {LEGAL.brand} fornece informações de forma prática e auxiliar, mas{' '}
        <strong className="text-gray-900 dark:text-white">não substitui</strong> medições físicas, manutenção
        preventiva ou verificações técnicas dos dispositivos e reservatórios.
      </p>
      <ul className="list-disc pl-5 space-y-2 mb-4">
        <li>
          <strong className="text-gray-900 dark:text-white">Limitações:</strong> não nos responsabilizamos por
          danos diretos ou indiretos (incluindo falta de água, transbordamentos ou danos a bombas) decorrentes
          de falhas de conexão, interrupção do serviço de nuvem, leituras imprecisas dos sensores ou bugs de
          software.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Automação:</strong> o uso de automação (controle de
          relés/bombas) deve ser feito sob supervisão. Recomenda-se fortemente o uso de sistemas de segurança
          físicos redundantes (como boias mecânicas).
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Disponibilidade:</strong> o serviço é fornecido
          &quot;como está&quot;, sujeito a manutenções e limitações de rede.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        6. Propriedade intelectual
      </h2>
      <p>
        Marcas, layout, software e conteúdo do {LEGAL.brand} são protegidos por direitos de propriedade
        intelectual. É vedada a reprodução não autorizada.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        7. Privacidade e dados pessoais
      </h2>
      <p>
        O tratamento de dados pessoais é regido pela{' '}
        <Link to="/privacidade" className="text-accent font-semibold hover:underline">
          Política de Privacidade
        </Link>
        . Você pode exercer seus direitos como titular pelo e-mail{' '}
        <a href={`mailto:${LEGAL.privacyEmail}`} className="text-accent font-semibold hover:underline">
          {LEGAL.privacyEmail}
        </a>
        .
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        8. Alterações e contato
      </h2>
      <p>
        Podemos alterar estes termos a qualquer momento, publicando a versão atualizada nesta página. O uso
        continuado após alterações implica concordância. Dúvidas:{' '}
        <a href={`mailto:${LEGAL.privacyEmail}`} className="text-accent font-semibold hover:underline">
          {LEGAL.privacyEmail}
        </a>
        .
      </p>
    </section>

    <p className="text-gray-600 dark:text-gray-400 text-sm border-t border-gray-200 dark:border-gray-700 pt-8">
      Veja a{' '}
      <Link to="/privacidade" className="text-accent font-semibold hover:underline">
        Política de Privacidade
      </Link>
      . Contato:{' '}
      <a href={`mailto:${LEGAL.privacyEmail}`} className="text-accent font-semibold hover:underline">
        {LEGAL.privacyEmail}
      </a>
    </p>
  </LegalDocumentLayout>
)

export default TermsOfUsePage
